import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/landing/LegalPage";

export const Route = createFileRoute("/legal/acik-riza")({
  head: () => ({
    meta: [
      { title: "Согласие на обработку данных — TurkeyDrive" },
      { name: "description", content: "Açık Rıza Metni / Согласие на обработку персональных данных TurkeyDrive." },
      { property: "og:title", content: "Согласие на обработку данных — TurkeyDrive" },
      { property: "og:description", content: "Açık Rıza Metni / Согласие на обработку персональных данных TurkeyDrive." },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <LegalPage slug="acik-riza" />,
});
